<style>
  .ivu-modal-footer{border: none;}
  .ivu-select-multiple{height: 32px;}
  .ivu-select-selection{z-index:100;}
</style>
<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="区域" prop="schoolRegion">
               <Select v-model="query.schoolRegion" clearable>
                 <Option
                   v-for="item in schoolRegionlist"
                   :key="item.index"
                   :value="item.index"
                   :label="item.type"
                 ></Option>
               </Select>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="学校" prop="schoolName">
                <Input
                  v-model="query.schoolName"
                  clearable
                  placeholder="请输入"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="地丘号" prop="landnum">
                <Input
                  v-model="query.landnum"
                  clearable
                  placeholder="请输入"
                />
              </form-item>
            </i-col>

            <i-col span="6">
              <form-item label="购房" prop="buyhouse">
                <Select v-model="query.buyhouse" clearable>
                  <Option
                    v-for="item in buyhouselist"
                    :key="item.index"
                    :value="item.index"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="户籍" prop="register">
                <Select v-model="query.register" clearable>
                  <Option
                    v-for="item in registerlist"
                    :key="item.index"
                    :value="item.index"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="租赁年限" prop="leaseYears">
                <Select v-model="query.leaseYears" clearable>
                  <Option
                    v-for="item in leaseYearslist"
                    :key="item.index"
                    :value="item.index"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
          </row>
        </i-form>
      </div>

      <div class="table-data">
        <div class="bottomtable">
          <i-table
            :columns="tableHeader"
            :border="true"
            :loading="isLoading"
            :data="tableData"
            stripe
            ref="table"
            @on-selection-change="handleSelect"
          >
            <template slot-scope="{ row, index }" slot="action">
              <span @click="handleClickDetail(row, 'detail')" class="action">[详情]</span>
              <span class="action" @click="handleClickDetail(row, 'edit')">[编辑]</span>
             <Poptip
                transfer
                confirm
                title="确认删除?"
                placement="left"
                @on-ok="handleClickDetail(row, 'del')"
              >
                <span class="action">[删除]</span>
              </Poptip>

            </template>

          </i-table>
        </div>
        <div class="page">
          <page
            :total="total"
            :current="pageNum"
            :page-size="pageSize"
            :page-size-opts="pagesizeopts"
            @on-change="pageChange"
            show-total
            show-sizer
            @on-page-size-change="onpagesizechange"
          />
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
const {

} = api;
export default {
  name: "distributionRules",
  components: {
    pageHead,
  },

  data() {
    return {
      title:'自动分配规则',
      header: {
        token: window.sessionStorage.getItem("token"),
      },
      btnList: [
        {name: "搜索",type: "search"},
        {name: "重置",type: "refsh"},
        {name: "新增",type: "add"}
      ],
      isLoading: false,
      isBtbLoading: false,
      pageNum: 1,
      pageSize: 50,
      pagesizeopts:[50,100,150,200],
      total: 0,
      query:{
        landnumname:'',
        landnum:'',
        isCommit:'',
        communityId1:""
      },
      tableData:[],
      selectedList:[],
      leaseYearslist:[
        {index: 0,type: "不满1年"},
        {index: 1,type: "满1年"},
        {index: 2,type: "满2年"},
        {index: 3,type: "满3年"},
        {index: 4,type: "满4年"},
        {index: 5,type: "满5年"}
      ],
      registerlist:[
        {index: 1,type: "市城区"},
        {index: 2,type: "非市城区"}
      ],
      buyhouselist:[
        {index: 1,type: "购房"},
        {index: 2,type: "租赁"}
      ],
      isCommittype:[
        {index: 1,type: "是"},
        {index: 2,type: "否"}
      ],
      schoolRegionlist:[
        {index: 0,type: "市直"},
        {index: 1,type: "油田"},
        {index: 2,type: "开发区"},
        {index: 3,type: "华龙区"},
        {index: 4,type: "示范区"},
      ],
      tableHeader: [
        {type: "selection",width:70,align: "center"},
        {title: "区域",key: "studentName",align: "center"},
        {title: "学校",key: "studentIdcardNum",align: "center"},
        {title: "地丘号",key: "communityName",align: "center"},
        {title: "购房类型",key: "area",align: "center"},
        {title: "户籍",key: "ischengqu",align: "center"},
        {title: "租赁年限",key: "estateCertType",align: "center"},
        {title: "操作",slot: "action",align: "center"},
      ],
    };
  },
  methods: {
    formateData(data) {
      let returnData = data.map((item) => {
        return {
          value: {
            communityId: item.communityId,
            childrenIdList: item.childrenIdList,
          },
          label: item.communityName,
          children: item.children.length ? this.formateData(item.children) : [],
        };
      });
      return returnData;
    },
    communityChange1(value) {
      let returndata = value[value.length - 1];
      this.query.communityId1 = returndata.communityId;
    },
    handleClickDetail(item, type) {
      console.log(item, type);
      if (type == "detail") {
        this.$router.push({
          name: "landnumdetail",
          query: {type:'detail'}
        });
      }else if(type == "edit"){
        this.$router.push({
          name: "landnumadd",
          query: {type:'edit'}
        });
      }else if (type == "del") {

      }
    },
    handleSelect(selection) {
      this.selectedList = [];
      console.log(selection);
      selection.forEach((item) => {
        this.selectedList.push(item.studentName);
      });
    },
    onpagesizechange(e){
      console.log(e)
      this.pageSize=e
      this.pageNum = 1;

    },
    dorefresh(){
      this.pageNum = 1;
      this.query = {
        landnumname:'',
        landnum:'',
        studentType:'',
        isCommit:''
      }

    },
    handleBtn(type) {
      if (type == "search") {

      }
      else if (type == "refsh"){
        this.dorefresh()
      }
      else if (type == "add") {
        this.$router.push({
          name: "landnumadd",
          query: {type:'add'}
        });
      }
    },
    pageChange(val) {
      this.pageNum = val;

    },
  },
  created() {

  },
  mounted() {},
};
</script>

<style  scoped lang="less">
.content {
  margin:0 20px 20px 20px;
}
.toptab{width: 100%;display: flex;display: -webkit-flex;justify-content: space-between;border-bottom: solid 1px #EEEEEE;}
.toptableft{width: 100%;display: flex;display: -webkit-flex;}
.toptableft span{width: 86px;height: 32px;text-align: center;line-height: 32px;font-size: 16px;}
.bottombtn{width:150px;text-align: center;height:32px;line-height:32px;font-size: 16px;color: #FFFFFF;border-radius: 6px;background: #0097FF;}
.activetap{background: #FF7B44;color: #FFFFFF;border-radius: 6px 6px 0 0;}
.nomaltap{background: #FFFFFF;color: #666666;border-radius: 6px 6px 0 0;border: solid 1px #EEEEEE;}
.search {width: 100%;background-color: white;border-radius: 5px;padding: 20px;margin-bottom: 20px;}

.label {width: 100px;}
.time {width: 100%;}
.bottomtable{width: 100%;padding:20px;}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  // padding: 20px;
  min-height: calc(100vh - 450px);
  .page {width: 100%;padding-bottom:20px;display: flex;justify-content: center;}
  .success {color: #ff7b44;}
  .action {color: #5e6d94;cursor: pointer;margin-right: 10px;}
}

.statistics {padding: 10px 0;text-align: right;}

.estateTitle {color: #ff7b44;font-weight: bold;}

.estateNO {color: #ff7b44;font-weight: 400;background: #ffefe9;margin: 0 15px 10px 0;}
.topformbox{width: 100%;background: #F8F8F8;height: 80px;border-radius: 4px 4px 0px 0px;display: flex;display: -webkit-flex;align-items: center;justify-content: space-between;}
.topformbox .ivu-form{width: 100%;height: 80px;display: flex;display: -webkit-flex;align-items: center;}
.topformbox .ivu-form .ivu-form-item{margin: 0;width: 360px;}
.topformbox .ivu-form .ivu-form-item:nth-child(1){margin-left: 21px;}
.topformboxright{height: 80px;display: flex;display: -webkit-flex;align-items: center;}
.topformboxright span:nth-child(1){width: 92px;height: 28px;background: #FF7943;border-radius: 4px;text-align: center;line-height: 28px;font-size: 14px;color: #FFFFFF;margin-right: 20px;}
.topformboxright span:nth-child(2){width:120px;height: 28px;background: #F9FAFA;border: 1px solid #DEDEDE;border-radius: 4px;text-align: center;line-height: 28px;font-size: 14px;color: #4B4B4B;margin-right: 20px;}

.schoolbox{width: 100%;}


</style>
